"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
// #region Progress Wrapper
var progressWrapperStyles = function (props) {
    var theme = props.theme, percent = props.percent;
    return {
        width: '100%',
        padding: 0,
        alignItems: 'center',
        position: 'relative',
        background: theme.colors.blue.pastel,
        borderRadius: theme.radii.lg + theme.radii.xs,
        height: 5,
        justifyContent: 'flex-end',
        marginRight: 15,
        transition: 'all 0.3s linear',
        '&::before': {
            content: '""',
            position: 'absolute',
            padding: 0,
            left: 0,
            top: 0,
            zIndex: 1,
            width: percent + "%",
            transition: 'all 0.3s linear',
            background: theme.colors.blue.haptik,
            borderRadius: theme.radii.lg + theme.radii.xs,
            height: '100%',
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            background: '#ffffff',
            opacity: 0,
            zIndex: 1,
            height: '100%',
            left: percent + "px",
            width: percent + "%",
            borderRadius: theme.radii.lg + theme.radii.xs,
        },
    };
};
var pulse = function (percent) {
    return styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["0% {\n    transform: translate(-", "%) scaleX(0);\n    opacity: .1\n}\n\n20% {\n    transform: translate(-", "%) scaleX(0);\n    opacity: .5\n}\n\nto {\n    transform: translate(0) scaleX(1);\n    opacity: 0\n}"], ["0% {\n    transform: translate(-", "%) scaleX(0);\n    opacity: .1\n}\n\n20% {\n    transform: translate(-", "%) scaleX(0);\n    opacity: .5\n}\n\nto {\n    transform: translate(0) scaleX(1);\n    opacity: 0\n}"])), percent, percent);
};
var animation = function (props) {
    var percent = props.percent;
    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &::after {\n      animation: ", " 2s ease-out infinite;\n      animation-delay: 0.2s;\n    }\n  "], ["\n    &::after {\n      animation: ", " 2s ease-out infinite;\n      animation-delay: 0.2s;\n    }\n  "])), pulse(percent));
};
var ProgressWrapper = styled_components_1["default"](box_1["default"])(progressWrapperStyles, animation);
// TODO: Move this to Relements
var ProgressBar = function (_a) {
    var percent = _a.percent, autoProgressAfter = _a.autoProgressAfter, showLoaderAfterComplete = _a.showLoaderAfterComplete;
    var _b = react_1["default"].useState(0), progressPercent = _b[0], setProgressPercent = _b[1];
    var _c = react_1["default"].useState(), timer = _c[0], setTimer = _c[1];
    react_1["default"].useEffect(function () {
        if (autoProgressAfter) {
            if (progressPercent >= 100) {
                clearInterval(timer);
            }
            else {
                var id = setInterval(function () {
                    setProgressPercent(progressPercent + 10);
                }, autoProgressAfter);
                setTimer(id);
            }
            return function () { return clearInterval(timer); };
        }
        if (!autoProgressAfter) {
            setProgressPercent(percent);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [progressPercent, percent]);
    return (react_1["default"].createElement(box_1["default"], { style: {
            padding: '0',
            alignItems: 'center',
            width: '100%',
            overflow: 'hidden',
        } },
        react_1["default"].createElement(ProgressWrapper, { percent: progressPercent }),
        react_1["default"].createElement(text_1["default"], { variant: "body.md" }, showLoaderAfterComplete && progressPercent === 100 ? (react_1["default"].createElement(box_1["default"], { style: {
                padding: '0',
                width: 15,
                height: 15,
            } },
            react_1["default"].createElement(loader_1["default"], { themed: true }))) : (progressPercent + "%"))));
};
exports["default"] = ProgressBar;
var templateObject_1, templateObject_2;
